import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4200Model } from './kymw4200.model';
import { KYMW4200OutputModel } from './vo/kymw4200-output.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { CandidateGoodsSearchConditionModel } from './vo/candidate-goods-search.model';
import { GetCandidateGoodsProofListService } from './api-services/get-candidate-goods-proof-list.service';
import { OutputGoodsMasterProofService } from './api-services/output-goods-master-proof.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { CellType, CellRange, GridPanel, FlexGrid } from '@grapecity/wijmo.grid';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { DataGridUtil } from './../../../commons/kymw00/data-grid-util';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/**
 * 商品マスタプルーフ画面を管理するクラス
 *
 * @export KYMW4200Component
 * @class KYMW4200Component
 */
@Component({
  selector: 'app-kymw4200',
  templateUrl: 'kymw4200.component.html',
  styleUrls: ['kymw4200.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4200Component extends PlessViewHelperSub implements OnInit {

  kymw4200Model: KYMW4200Model = new KYMW4200Model();
  // 親画面からの連携値
  param: any;

  @ViewChild('dtg_CandidateGoodsProofList', { static: true }) dtg_CandidateGoodsProofList: FlexGrid;
  @ViewChild('btn_Seach', { static: true }) btn_Seach: ElementRef;
  @ViewChild('btn_Out', { static: true }) btn_Out: ElementRef;
  @ViewChild('btn_Back', { static: true }) btn_Back: ElementRef;
  @ViewChild('btn_Next', { static: true }) btn_Next: ElementRef;
  @ViewChild('btn_AllSelect', { static: true }) btn_AllSelect: ElementRef;
  @ViewChild('btn_AllUnSelect', { static: true }) btn_AllUnSelect: ElementRef;

  // 商品検索画面のVO
  private kymw0300InputVO: KYMW0300InputModel = null;
  // DataGridの列名とテーブル物理名を紐付ける連想配列Object
  private tableName: Object;
  public kymw0300ComponentRef: ComponentRef<any> = null;
  public kymw0300Component: KYMW0300Component;
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  /**
   * Creates an instance of KYMW4200Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {GetCandidateGoodsProofListService} getCandidateGoodsProofListService
   * @param {OutputGoodsMasterProofService} outputGoodsMasterProofService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW4200Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private getCandidateGoodsProofListService: GetCandidateGoodsProofListService,
    private outputGoodsMasterProofService: OutputGoodsMasterProofService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public viewContainerRef: ViewContainerRef,
  ) {
    super(kymw00Model);

    this.tableName = new Object();
    this.tableName['ClassCode'] = 'ClassCode';
    this.tableName['SmallClassCode'] = 'SmallClassCode';
    this.tableName['PCode'] = 'PCode';
    this.tableName['ItemCode'] = 'ItemCode';
    this.tableName['GuideGoodsName'] = 'GuideGoodsName';
    this.tableName['GuideStandardName'] = 'GuideStandardName';
  }

  /**
   * 初期処理
   *
   * @memberof KYMW4200Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4200';
    // ヘッダーを右寄せ
    this.dtg_CandidateGoodsProofList.itemFormatter = function (panel: GridPanel, r: number, c: number, cell: HTMLElement) {
      if (panel.cellType === CellType.ColumnHeader) {
        cell.style.textAlign = 'left';
      }
    };

    this.dtg_CandidateGoodsProofList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の背景色設定処理
      this.setColorPattern();
      this.dtg_CandidateGoodsProofList.select(-1, -1);
    });

    // チェックボックスセルをクリックしたときにチェックボックスにチェックを入れる
    this.dtg_CandidateGoodsProofList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      var ht = this.dtg_CandidateGoodsProofList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`TargetFlg_${ht.row}`).click();
      }
    });
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド
   *
   * @memberof KYMW4200Component
   */
  public eventOutput_CLICKHandler(): void {
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const voList: Array<any> = new Array<any>();

    for (let i = Number(0); i < this.kymw4200Model.candidateGoodsProofList.length; i++) {
      const data: any = this.kymw4200Model.candidateGoodsProofList[i];
      if (data.TargetFlg) {
        const vo: KYMW4200OutputModel = new KYMW4200OutputModel();
        vo.PCode = data.PCode;
        vo.ItemCode = data.ItemCode;
        voList.push(vo);
      }
    }

    // 商品マスタプルーフ出力API実行
    this.outputGoodsMasterProofService.execute(this.kymw4200Model, voList, (data: any) => {
      // ファイル名の設定
      const fileName = '商品マスタプルーフ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   * 前へをクリックした時に呼び出されるメソッド
   *
   * @memberof KYMW4200Component
   */
  public eventBackHandler(): void {
    // 現在のページ番号-1を設定し、リストを取得
    let pageNo = this.kymw4200Model.pageNo;
    pageNo = pageNo - 1;
    this.getCandidateGoodsProofList(pageNo);
  }

  /**
   * 次へをクリックした時に呼び出されるメソッド
   *
   * @memberof KYMW4200Component
   */
  public eventNextHandler(): void {
    // 現在のページ番号+1を設定し、リストを取得
    let pageNo = this.kymw4200Model.pageNo;
    pageNo = pageNo + 1;
    this.getCandidateGoodsProofList(pageNo);
  }

  /**
   * 商品検索画面
   *
   * @memberof KYMW4200Component
   */
  public eventSeach_CLICKHandler(): void {
    if (this.kymw0300InputVO == null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示しない（企画検索フラグ:0）
    this.kymw0300InputVO.catalogSearchFlg = 0;

    // 商品検索画面(モーダル)を表示する。
    const componentRef = this.dialogServiceSub.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter = (outputVO: KYMW0300OutputModel) => this.setKYMW0300Parameter(outputVO);

    instance.closeFunction = ()=>{
      componentRef.close();
    }
  }

  /**
   * 商品検索画面 Output時
   *
   * @param {KYMW0300OutputModel} outputVO
   * @memberof KYMW4200Component
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    // 検索時はページ番号を1に初期化する
    this.kymw4200Model.pageNo = 1;

    // 検索画面の検索条件を保持
    this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);

    // 検索パラメタ設定
    const vo: CandidateGoodsSearchConditionModel = new CandidateGoodsSearchConditionModel();
    vo.pcode = this.kymw0300InputVO.pcode;
    vo.itemCode = this.kymw0300InputVO.itemCode;
    vo.ebaseSpecCode = this.kymw0300InputVO.ebaseSpecCode;
    vo.dataType = this.kymw0300InputVO.dataType;
    vo.janCode = this.kymw0300InputVO.janCode;
    vo.makerName = this.kymw0300InputVO.makerName;
    vo.ordrClientCode = this.kymw0300InputVO.ordrClientCode;
    vo.ordrClientKanji = this.kymw0300InputVO.ordrClientKanji;
    vo.payeeClientCode = this.kymw0300InputVO.payeeClientCode;
    vo.payeeClientKanji = this.kymw0300InputVO.payeeClientKanji;
    vo.classCode = this.kymw0300InputVO.classCode;
    vo.middleClassCode = this.kymw0300InputVO.middleClassCode;
    vo.smallClassCode = this.kymw0300InputVO.smallClassCode;
    vo.registDateFrom = this.kymw0300InputVO.registDateFrom;
    vo.registDateTo = this.kymw0300InputVO.registDateTo;
    vo.updateDateFrom = this.kymw0300InputVO.updateDateFrom;
    vo.updateDateTo = this.kymw0300InputVO.updateDateTo;
    vo.admitStatus = this.kymw0300InputVO.admitStatus;
    vo.buyerCode = this.kymw0300InputVO.buyerCode;
    vo.guideGoodsNameList = this.kymw0300InputVO.guideGoodsNameList;
    vo.guideStandardNameList = this.kymw0300InputVO.guideStandardNameList;
    vo.tagIdList = this.kymw0300InputVO.tagId;
    vo.tagSearchType = this.kymw0300InputVO.tagSearchType;
    vo.goodsMarkList = this.kymw0300InputVO.goodsMark;
    vo.goodsMarkSearchType = this.kymw0300InputVO.goodsMarkSearchType;
    vo.coopCodeList = this.kymw0300InputVO.coopCodeList;
    vo.pcodeList = this.kymw0300InputVO.pcodeList;
    vo.itemCodeList = this.kymw0300InputVO.itemCodeList;
    vo.goodsDiv = this.kymw0300InputVO.goodsDiv;
    vo.pageNo = this.kymw4200Model.pageNo;
    vo.dataKbnFlg = this.kymw0300InputVO.dataKbnFlg;

    // 商品マスタプルーフ候補一覧取得API実行
    this.getCandidateGoodsProofListService.execute(this.kymw4200Model, vo, () => {},
      () => {
        // 画面の値クリア、ボタンの非活性
        this.kymw4200Model.setCandidateGoodsProofList(null);
        // エラーメッセージ表示
        this.dialogServiceSub.openAlertGetMessage('E0100');
      }
    );
  }

  /**
   * 候補リストを取得する
   *
   * @private
   * @param {number} pageNo
   * @memberof KYMW4200Component
   */
  private getCandidateGoodsProofList(pageNo: number): void {
    this.kymw4200Model.pageNo = pageNo;

    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo: CandidateGoodsSearchConditionModel = new CandidateGoodsSearchConditionModel();
    vo.pageNo = pageNo;
    vo.pcode = this.kymw0300InputVO.pcode;
    vo.itemCode = this.kymw0300InputVO.itemCode;
    vo.ebaseSpecCode = this.kymw0300InputVO.ebaseSpecCode;
    vo.dataType = this.kymw0300InputVO.dataType;
    vo.janCode = this.kymw0300InputVO.janCode;
    vo.makerName = this.kymw0300InputVO.makerName;
    vo.guideGoodsNameList = this.kymw0300InputVO.guideGoodsNameList;
    vo.guideStandardNameList = this.kymw0300InputVO.guideStandardNameList;
    vo.ordrClientCode = this.kymw0300InputVO.ordrClientCode;
    vo.ordrClientKanji = this.kymw0300InputVO.ordrClientKanji;
    vo.payeeClientCode = this.kymw0300InputVO.payeeClientCode;
    vo.payeeClientKanji = this.kymw0300InputVO.payeeClientKanji;
    vo.classCode = this.kymw0300InputVO.classCode;
    vo.middleClassCode = this.kymw0300InputVO.middleClassCode;
    vo.smallClassCode = this.kymw0300InputVO.smallClassCode;
    vo.registDateFrom = this.kymw0300InputVO.registDateFrom;
    vo.registDateTo = this.kymw0300InputVO.registDateTo;
    vo.updateDateFrom = this.kymw0300InputVO.updateDateFrom;
    vo.updateDateTo = this.kymw0300InputVO.updateDateTo;
    vo.coopCodeList = this.kymw0300InputVO.coopCodeList;
    vo.admitStatus = this.kymw0300InputVO.admitStatus;
    vo.buyerCode = this.kymw0300InputVO.buyerCode;
    vo.goodsDiv = this.kymw0300InputVO.goodsDiv;
    vo.pcodeList = this.kymw0300InputVO.pcodeList;
    vo.sortKey = this.kymw4200Model.sortKey;
    vo.orderKey = this.kymw4200Model.orderKey;
    vo.dataKbnFlg = this.kymw0300InputVO.dataKbnFlg;

    // 商品マスタプルーフ候補一覧取得API実行
    this.getCandidateGoodsProofListService.execute(this.kymw4200Model, vo, () => {});
  }

  /**
   * データグリッドヘッダークリックした時に呼び出されるメソッド
   *
   * @param {MouseEvent} e コールバック・イベントへの参照
   * @returns {void}
   * @memberof KYMW4200Component
   */
  public eventCandidateGoodsListHandler(e: any): void {
    const grid: FlexGrid = this.dtg_CandidateGoodsProofList;

    // データが0件の場合は何もしない
    if (DataGridUtil.isSortable(e, grid)) {
      // ソート対象でないヘッダーの場合は何もしない
      if (!(this.dtg_CandidateGoodsProofList.columns[grid.hitTest(e).col].binding in this.tableName)) {
        return;
      }

      // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
      this.kymw4200Model.orderKey = DataGridUtil.switchHeaderText(e, grid);

      // クリックされたデータグリッドの列から、DBの物理項目を取得
      this.kymw4200Model.sortKey = this.tableName[grid.columns[grid.hitTest(e).col].binding];

      // １ページ目を検索
      this.getCandidateGoodsProofList(1);
    }
  }

  /**
   * 全選択ボタンクリックイベント
   *
   * @memberof KYMW4200Component
   */
  public eventAllSelect_CLICKHandler(): void {
    this.kymw4200Model.updateAllSelect(true);
  }

  /**
   * 全解除ボタンクリックイベント
   *
   * @memberof KYMW4200Component
   */
  public eventAllUnSelect_CLICKHandler(): void {
    this.kymw4200Model.updateAllSelect(false);
  }

  /**
   * データグリッド行の背景色設定
   *
   * @memberof KYMW4200Component
   */
  public setColorPattern(): void {
    const grid: FlexGrid = this.dtg_CandidateGoodsProofList;
    const rowIndex: number = grid.selection.row;                                // 選択行インデックス

    for (let loop = Number(0); loop < grid.rows.length; loop++) {
      // 状態のチェック(0：通常、1：他のユーザーが使用、2：取扱終了日が指定されている)
      if (grid.rows[loop].dataItem.DataKbn === '1') {                        // 「1：他のユーザーが使用」の場合
        if (rowIndex === loop) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'use-otheruser-pcode';
        }
      } else if (grid.rows[loop].dataItem.DataKbn === '2') {                 // 「2：取扱終了日が指定されている」の場合
        if (rowIndex === loop) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'specified-handling-period-pcode';
        }
      } else {                                                                  // 上記以外の場合
        if (rowIndex === loop) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'other-pcode';
        }
      }
    }
  }
}
